import { ChildrenItem } from "dependencies/base"
import { Code } from "./model"
import { home, bs, appHome } from "./diffrence_options"
import bigScreenIcon from "assets/images/leftMenu/component/cx_label.png"

let icon = "icon-portal-code"
export let code_children = []
export let bigScreen_code_children = []
export let app_code_children = []
for (let i = 0; i < home.length; i++) {
  code_children.push(new ChildrenItem("二维码样式" + (i + 1), icon, "cxCode", new Code(home[i])))
}
for (let i = 0; i < bs.length; i++) {
  bigScreen_code_children.push(new ChildrenItem("二维码样式" + i, bigScreenIcon, "cxCode", new Code(bs[i])))
}
for (let i = 0; i < appHome.length; i++) {
  app_code_children.push(new ChildrenItem("二维码样式" + (i + 1), icon, "cxCode", new Code(appHome[i])))
}
